/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import {
  Accordion, AccordionSummary, AccordionDetails, SvgIcon, CardMedia,
} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import MuiTypography from '@mui/material/Typography';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import SvgCaretDown from '@digital-hig/icon/lib/build/ui-controls/caret-down';
import SvgCaretRight from '@digital-hig/icon/lib/build/ui-controls/caret-right';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'isomorphic-dompurify';
import AccordionRootElement from './style';

export const isItemAvailableInside = (item, items) => {
  if (Array.isArray(items[item]) && items[item]?.length) {
    return true;
  }
  if (typeof items[item] === 'string') {
    return true;
  }
  if (!Array.isArray(items[item]) && typeof items[item] === 'object' && Object.keys(items[item])?.length) {
    return true;
  }
  return false;
};
const AccordionList = ({
  items, loading, size, imgKey, titleKey, dataWatLoc,
}) => {
  const { t } = useTranslation();

  return (
    <AccordionRootElement>
      {Object.keys(items).map((item, index) => (
        isItemAvailableInside(item, items) && (
          <Accordion className="accordion-list" key={`solution-${index}`}>
            <AccordionSummary data-wat-val={DOMPurify.sanitize(item)} data-wat-loc={dataWatLoc} className="accordion-heading">
              <MuiTypography variant="headline-smaller" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t(item)) }} />
              <SvgCaretDown width="12px" />
            </AccordionSummary>
            <AccordionDetails className="accordion-content">
              {Array.isArray(items[item]) && !imgKey && (
                <Box component="ul">
                  {items[item]?.map((value, valueIndex) => (
                    <Box
                      component="li"
                      key={`${value}-${valueIndex}`}
                    >
                      {t(value)}
                    </Box>
                  ))}
                </Box>
              )}
              {typeof items[item] === 'string' && (
                <MuiTypography className="details-list-items" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t(items[item])) }} />
              )}
              {!Array.isArray(items[item]) && typeof items[item] === 'object' && (
                <Box className="treeview-section">
                  <TreeView
                    aria-label="minimal tree view"
                    defaultCollapseIcon={(
                      <SvgIcon>
                        <SvgCaretDown />
                      </SvgIcon>
                    )}
                    defaultExpandIcon={(
                      <SvgIcon>
                        <SvgCaretRight />
                      </SvgIcon>
                    )}
                    size="dense"
                  >
                    {Object.keys(items[item]).map(
                      (value, valueIndex) => (
                        <TreeItem
                          key={`root-${valueIndex}`}
                          nodeId={`root-${valueIndex}`}
                          label={t(value)}
                        >
                          {items[item][value] && items[item][value]?.map(
                            (itr, childIndex) => (
                              <TreeItem
                                key={`child-${childIndex}`}
                                nodeId={`child-${childIndex}`}
                                label={t(itr)}
                              />
                            ),
                          )}
                        </TreeItem>
                      ),
                    )}
                  </TreeView>
                </Box>
              )}
              {imgKey && (
                <>
                  {items[item]?.map((value, valueIndex) => (
                    <Box
                      className="content-row"
                      key={`value-${valueIndex}`}
                    >
                      <Typography
                        variant="body-copy-large"
                        className="first-col"
                      >
                        {t(value[titleKey])}
                      </Typography>
                      <Typography
                        variant="body-copy-medium"
                        className="second-col"
                      >
                        {t(value?.description) || t('Building Architecture specialized partners are focused on Autodesk solutions and services to optimize building design through improved team collaboration, improved data handover, reduced overall design time and increased workoad capacity.')}
                      </Typography>
                      <Box className="third-col">
                        <CardMedia
                          alt={value[titleKey]}
                          component="img"
                          image={value[imgKey]}
                          data-testid="card-media"
                        />
                      </Box>
                    </Box>
                  ))}
                </>
              )}
            </AccordionDetails>
          </Accordion>
        )
      ))}
      {loading
            && [...Array(size).keys()].map((idx) => (
              <Skeleton
                key={`information-${idx}`}
                height="56px"
                className="skeleton-shimmer"
              />
            ))}
    </AccordionRootElement>
  );
};

AccordionList.propTypes = {
  items: PropTypes.shape({}),
  loading: PropTypes.bool,
  size: PropTypes.number,
  imgKey: PropTypes.string,
  titleKey: PropTypes.string,
  dataWatLoc: PropTypes.string,
};
AccordionList.defaultProps = {
  items: {},
  loading: false,
  size: 0,
  imgKey: '',
  titleKey: '',
  dataWatLoc: '',
};

export default AccordionList;
